import style from '#src/client/common/errors/ErrorText.module.css';

function ErrorText(props) {
    return (
        <Show when={props.error}>
            <span class={`${style.error} ${props.hasSpacing ? style.spacing : ''}`}>{props.error}</span>
        </Show>
    );
}

export default ErrorText;